import { CatalogByIdResponse } from "../../../../../../../service/catalog/response";


const formatCatalogResponse = ({ response }: { response: CatalogByIdResponse }) => {

  const categories = !response.errors
    ? response?.categories?.map((category) => {
      return {
        id: category?.id,
        name: category.name,
        subcategories: category.subcategories.map((sub) => ({
          id: sub.id,
          name: sub.name,
          requestText: sub.requestText,
          user: sub.user ? {
            id: sub.user.id,
            firstName: sub.user.firstName,
            lastName: sub.user.lastName,
            fullName: sub.user.firstName + " " + sub.user.lastName,
            email: sub.user.email,
            phone: sub.user.phone,
          } : null,
          priority: {
            id: sub.priority.id,
            name: sub.priority.name,
          },
        }))
      }
    })
    : []

  return {
    categories
  }
}


export { formatCatalogResponse }